import ContentStorage, { ComponentKeys } from '../../../tnew/content/ContentStorage';


const get = name => ContentStorage.get(ComponentKeys.STATIC_BEST_AVAILABLE, name);


class StaticBestAvailable {
  static get reservationErrorMessage() {
    return get('ReservationErrorMessage');
  }
}


export default StaticBestAvailable;



// WEBPACK FOOTER //
// ./src/events/detail/components/StaticBestAvailable.js